<div *ngIf="isOpen" class="fixed inset-0 z-[1000] flex items-center justify-center p-4" @fade>
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black/40 backdrop-blur-sm" (click)="options?.cancelText ? cancel() : confirm()"></div>

  <!-- Dialog -->
  <div class="relative w-full max-w-md overflow-hidden glass-card rounded-2xl animate-entrance" 
       @slideUp
       role="dialog" 
       aria-modal="true">
    
    <!-- Content Area -->
    <div class="p-6 md:p-8">
      <div class="flex items-start gap-4">
        <!-- Icon based on type -->
        <div [ngClass]="{
          'bg-danger-bg text-danger': options?.type === 'danger',
          'bg-warning-bg text-warning': options?.type === 'warning',
          'bg-gold-subtle text-gold': options?.type === 'info' || !options?.type
        }" class="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center">
          <i class="pi" [ngClass]="{
            'pi-exclamation-circle text-xl': options?.type === 'danger',
            'pi-exclamation-triangle text-xl': options?.type === 'warning',
            'pi-info-circle text-xl': options?.type === 'info' || !options?.type
          }"></i>
        </div>

        <div class="flex-1">
          <h3 class="text-xl font-bold text-primary font-display mb-2">
            {{ options?.title || 'Confirmation' }}
          </h3>
          <p class="text-text-muted leading-relaxed">
            {{ options?.message }}
          </p>
        </div>
      </div>
    </div>

    <!-- Actions Area -->
    <div class="px-6 py-4 bg-gray-50/50 flex flex-row-reverse gap-3">
      <button 
        (click)="confirm()"
        [ngClass]="{
          'bg-danger hover:bg-red-600': options?.type === 'danger',
          'bg-warning hover:bg-amber-600': options?.type === 'warning',
          'bg-gold hover:bg-gold-dark': options?.type === 'info' || !options?.type
        }"
        class="px-6 py-2.5 rounded-xl text-white font-semibold transition-all duration-200 shadow-sm hover:shadow-md cursor-pointer">
        {{ options?.confirmText || 'Confirm' }}
      </button>

      <button 
        *ngIf="options?.cancelText !== ''"
        (click)="cancel()"
        class="px-6 py-2.5 rounded-xl bg-white border border-border text-text font-medium hover:bg-gray-50 transition-all duration-200 cursor-pointer">
        {{ options?.cancelText || 'Cancel' }}
      </button>
    </div>
  </div>
</div>
